/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeploymentBackfillRequest} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'
import {DeploymentBackfillResponse} from '@cash-web/protos/squareup/cash/cashdotapp/api.pb'


export const deploymentBackfill = (request: DeploymentBackfillRequest, options?: CashRequestOptions) => post<DeploymentBackfillRequest, DeploymentBackfillResponse>("/2.0/cash/deployment-backfill", request, {...options, rejectOnError: true })